import Vue from 'vue';
import Vuex from 'vuex';

export default class {
	constructor() {
		Vue.use(Vuex);
		const state = {
			isLoaded: true,
			isLoading: true,
			data: null,
			resetEmail: '',
			isAuthenticated: false,
			isAccountExist: true,
			isOptionalQuestions: false,
			isOptionalEmail: false,
			optionalQuestionsDismissed: false,
			isResetPassword: false,
			resetPasswordContent: '',
			isError: null,
			isDisabled: false,
			isRedirect: false,					
		};

		const getters = {
			isLoaded: state => state.isLoaded,
			isLoading: state => state.isLoading,
			data: state => state.data,
			resetEmail: state => state.resetEmail,
			isAuthenticated: state => state.isAuthenticated,
			isAccountExist: state => state.isAccountExist,
			isOptionalQuestions: state => state.isOptionalQuestions,
			isOptionalEmail: state => state.isOptionalEmail,
			isResetPassword: state => state.isResetPassword,
			resetPasswordContent: state => state.resetPasswordContent,
			isError: state => state.isError,
			isDisabled: state => state.isDisabled,
			isRedirect: state => state.isRedirect,
			optionalQuestionsDismissed: state => state.optionalQuestionsDismissed,
		};

		const mutations = {
			setLoaded(state, payload) {
				state.isLoaded = payload;
			},
			setLoading(state, payload) {
				state.isLoading = payload;
			},
			setData(state, payload) {
				state.data = payload;
			},
			setResetEmail(state, payload) {
				state.resetEmail = payload;
			},
			setAuthenticated(state, payload) {
				state.isAuthenticated = payload
			},
			setAccountExist(state, payload) {
				state.isAccountExist = payload
			},
			setOptionalQuestions(state, payload) {
				state.isOptionalQuestions = payload
			},
			setOptionalEmail(state) {
				state.isOptionalEmail = true
			},
			setRegistrationPage(state) {
				state.isAccountExist = false
				state.isAuthenticated = true
			},
			setResetPassword(state, payload) {
				state.isResetPassword = payload
			},
			setResetPasswordContent(state,payload) {
				state.resetPasswordContent = payload
			},
			setError(state, payload) {
				state.isError = payload
			},
			setDisabled(state, payload) {
				state.isDisabled = payload
			},
			setRedirect(state,payload) {
				state.isRedirect = payload
			},
			setStateValue(state, [key, value]) {
				state[key] = value
			},
		};

		const actions = {
			getData({ commit }, endpoint) {
				return new Promise(async res => {
					let success = false;
					await fetch(endpoint)
						.then(data => {
							//do some stuff
						})
						.catch(error => {
							console.error(error);
						})
						.finally(() => {
							res(success);
							commit('setLoaded', success);
						});
				});
			},
			getAccountInfo({commit}, {endpoint, loginEmail, loginPassword, afToken}) {
				// Potential return data
				// "succeeded": boolean,
				// "requiresTwoFactor": boolean
				return new Promise(async res => {
					// let success = false;
					await fetch(endpoint, {
						method: 'POST',
						headers: {
							'Content-type':'application/json',
							'X-XSRF-TOKEN': afToken,
						},
						body: JSON.stringify({
							"Email": loginEmail,
							"Password": loginPassword,
						}),
					})
					.then((response) => response.json())
					.then(data => {
						// console.log(data)
						let error = {code: 'error', description: 'An error has occurred, please check your email and password'}
						if(data.passwordExpired === true) {
							error = {code: 'PasswordExpired', description: 'Your password has expired, please reset it by clicking the "Forgot your password?" link below.' }
							commit('setError', error)
						}
						else if(data.succeeded === true) {
							commit('setError', false)
							commit('setAuthenticated', true);
						} else {
							commit('setError', error)
						}
						commit('setDisabled', false)
						commit('setLoading', false)
					})
					.catch(error => {
						console.error(error);
					})
					.finally(() => {
						// res(success);
						// Vue.prototype.$cookies.set("token", response.token, "7d");
						// commit('setAuthenticated', true);
					});
				});
			},
			getAccountCookie() {
				// if cookie exists set login to true
				// Vue.prototype.$cookies.get("token", response.token, "7d");
			},
			// used for registration
			setAccountInfo({commit}, {formData, afToken}) {
				return new Promise(async res => {
					// let success = false;
					await fetch(formData.endpoint, {
						method: 'POST',
						headers: {
							'Content-type':'application/json',
							'X-XSRF-TOKEN': afToken,
						},
						body: JSON.stringify({
							"Email": formData.registerEmailAddress,
							"Password": formData.registerPassword,
							"FirstName" : formData.registerFirstName,
							"LastName" : formData.registerLastName,
							"CountryId" : formData.registerCountry,
							"PostalCode" : formData.registerZipcode,
							"InvestorType" : formData.registerInvestor,  
							"EmailSignUp" : formData.registerEmailSignup
						})
					})
						.then((response) => response.json())
						.then(data => {
							// console.log(data)
							if(data.succeeded === true) {
								commit('setAuthenticated', true)
								commit('setAccountExist', true)
								commit('setOptionalQuestions', true)
								commit('setError', false)
							} else {
								commit('setError', data.errors)
								// console.log(data.errors)
							}
							commit('setDisabled', false)
							commit('setLoading', false)
						})
						.catch(error => {
							console.error(error);
						})
						// .finally(() => {
						// 	// res(success);
						// 	// Vue.prototype.$cookies.set("token", response.token, "7d");
						// 	console.log(`set account info`)
						// 	// bad
						// 	commit('setAuthenticated', true)
						// 	commit('setAccountExist', true)
						// 	commit('setOptionalQuestions', true)
						// });
				});
				
				
			},
			submitOptionalQuestions({commit}, {formData, endpoint}) {
				// console.log(typeof formData)
				let bodyContent = {
					formName : "",
					answers : []
				}			
				formData.forEach(answer => {
					// console.log(answer)
					if(!answer.name) {
						bodyContent.answers.push(answer)
					} else if (answer.name) {
						bodyContent.formName = answer.name
					}
				})
				// console.log(bodyContent)
				return new Promise(async res => {
					// let success = false;
					await fetch(endpoint,{
						method: 'POST',
						headers: {
							'Content-type':'application/json'
						},
						body: JSON.stringify(bodyContent),
					})
						.then((response) => response.json())
						.then(data => {
							// console.log(data)
							if(data.succeeded === true) {
								commit('setOptionalQuestions', false)
							}
							commit('setDisabled', false)
							commit('setLoading', false)
						})
						.catch(error => {
							console.error(error);
						})
						// .finally(() => {
						// 	// res(success);
						// 	commit('setOptionalQuestions', false);
						// });
				});
			},
			
			submitResetPassword({commit}, {email, endpoint}) {
				// console.log(email)
				// check for skip?
				return new Promise(async res => {
					// let success = false;
					await fetch(endpoint, {
						method: 'POST',
						headers: {
							'Content-type':'application/json'
						},
						body: JSON.stringify(email),
						// body: JSON.stringify('test@test')
					})
						.then((response) => response.json())
						.then(data => {
							// console.log(data.succeeded)
							if(data.succeeded === true) {
								// console.log('pw reset')
								commit('setError', false)
								commit('setResetPasswordContent', data.content)
								setTimeout(() => {
									commit('setResetPassword', false);
								}, 10000);
							} else {
								commit('setError', data.content)
							}
							setTimeout(() => {
								commit('setLoading', false)
								commit('setDisabled', false)
							}, 600);
							
						})
						.catch(error => {
							console.error(error);
						})
						// .finally(() => {
						// 	// res(success);
						// 	commit('setResetPassword', false);
						// });
				});
			},
			submitOptionalEmail({commit}, endpoint) {
				// check for skip?
				return new Promise(async res => {
					// let success = false;
					await fetch(endpoint)
						.then(data => {
							//do some stuff
						})
						.catch(error => {
							console.error(error);
						})
						.finally(() => {
							// res(success);
							commit('setOptionalEmail', true);
						});
				});
			},
		};

		this.store = new Vuex.Store({
			state,
			getters,
			mutations,
			actions,
		});
	}
}
